var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.itemDetail)?_vm._t("default",null,{"itemDetail":_vm.itemDetail}):_c('SpinnerCard')],2)}
var staticRenderFns = []

export { render, staticRenderFns }